const o="4.3.6";export{o as VERSION};
